import { Avatar } from "@mantine/core";

interface UserAvatarProps {
  name: string;
  photoURL: string;
  size: number;
}

const UserAvatar = (props: UserAvatarProps) => {
  const names = props.name.split(" "); // Split sentence into words
  let initials = names.map((name) => name.slice(0, 1)).join("");
  if (initials.length > 0)
    initials = initials[0] + initials[initials.length - 1];

  return (
    <>
      {props.photoURL && props.photoURL !== "" ? (
        <Avatar
          variant="transparent"
          style={{
            height: props.size,
            minHeight: props.size,
            width: props.size,
            minWidth: props.size,
            borderRadius: "50%",
          }}
          src={props.photoURL ?? ""}
        />
      ) : (
        <div
          style={{
            borderStyle: "solid",
            borderColor: "beige",
            borderRadius: "50%",
            backgroundColor: "beige",
            color: "black",
            height: props.size,
            minHeight: props.size,
            width: props.size,
            minWidth: props.size,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: props.size / 2 }}>{initials}</span>
        </div>
      )}
    </>
  );
};

export default UserAvatar;
